import { request } from 'utils';

export const getCurrentUser = () => request.get('/accounts/current');

export const signIn = (login: string, password: string) =>
  request.post(`/auth/token?email=${login}&password=${password}`);
